import React from "react";
import Checkbox from "../misc/elements/Checkbox";

const InputCheckbox = ({ onChecked, text, bol, otherItem = true }) => {
  return (
    <div
      className="divRow"
      onClick={() => onChecked(!bol)}
      style={{
        width: "50%",
        backgroundColor: "#5f5f5f",
        padding: "5px",
        borderRadius: ".5rem/.5rem",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      <div className="textBoldWhite" style={{ marginRight: "5px" }}>
        {text}
      </div>
      <Checkbox item={bol} otherItem={otherItem} />
    </div>
  );
};

export default InputCheckbox;
